import { Box, IconButton, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledGoogleMaps = {
  MapContainer: styled(Box)(({ theme }) => ({
    height: 360,
    minHeight: 360,
    flexShrink: 0,
    width: "100%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
  })),
  Tramo: styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  })),
  TramoHeader: styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  })),
  Distance: styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
  })),
  SearchControl: styled(Box)(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing(2),
  })),
  EmbedFrame: styled("iframe")({
    border: 0,
    width: "100%",
    height: 360,
    minHeight: 360,
    display: "block",
  }),
  RecorridoRow: styled(Paper)(({ theme }) => ({
    padding: 0,
    marginBottom: theme.spacing(1.5),
    overflow: "hidden",
    flexShrink: 0,
  })),
  RecorridoRowHeader: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 2),
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
  })),
  RecorridoSummary: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexGrow: 1,
    minWidth: 0,
  })),
  RecorridoIndexBadge: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    flexShrink: 0,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1,
  })),
  RecorridoTitle: styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
  })),
  RecorridoActions: styled(Box)({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  }),
  RecorridoActionButton: styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(0.5),
    color: theme.palette.action.active,
  })),
  RecorridoRowBody: styled(Box)(({ theme }) => ({
    padding: theme.spacing(1.5, 2, 2),
  })),
  DefaultsPanel: styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50],
  })),
  GestionPanel: styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  })),
  GestionCard: styled(Paper)(({ theme }) => ({
    padding: 0,
    marginBottom: theme.spacing(2),
    overflow: "hidden",
    flexShrink: 0,
  })),
  GestionHint: styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  })),
  RequerimientosLabel: styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    width: "100%",
    marginBottom: theme.spacing(0.5),
  })),
  GestionPanelTitle: styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(2),
  })),
  FieldApplyRow: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    width: "100%",
    "& > button": {
      flexShrink: 0,
      whiteSpace: "nowrap",
      marginTop: theme.spacing(1),
    },
  })),
  RequerimientosRow: styled(Box)(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    "& > button": {
      marginLeft: "auto",
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
  })),
};
